// extracted by mini-css-extract-plugin
export var prices = "prices-module--prices--4JbuV";
export var subHeader1 = "prices-module--subHeader1--2DJWO";
export var wrapItems = "prices-module--wrapItems--EDNhS";
export var item = "prices-module--item---VApQ";
export var button = "prices-module--button--XUBux";